/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var CopyActionIcon = createIcon("CopyActionIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#171717';
  return /*#__PURE__*/React.createElement("svg", {
    "data-replace-color": _color,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "M17.625 23.25h-13.5a1.5 1.5 0 01-1.5-1.5V5.625",
    stroke: _color,
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M21.375 18.159A1.8 1.8 0 0119.625 20H7.375a1.8 1.8 0 01-1.75-1.841V2.591A1.8 1.8 0 017.375.75h8.9c.47.002.917.197 1.238.539l3.349 3.524c.331.352.515.817.513 1.3v12.046Z",
    stroke: _color,
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}, {
  "replaceColor": true
});